// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bv1ejb{padding-left:var(--ds-space-300,24px)}\n._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._19pk1jfw{margin-top:var(--ds-space-500,40px)}\n._1bsb1gwv{width:360px}\n._1bsb1lit{width:10pc}\n._4t3iplmo{height:156px}\n._otyr1ejb{margin-bottom:var(--ds-space-300,24px)}\n._u5f31ejb{padding-right:var(--ds-space-300,24px)}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
